import { LegalLayout } from './LegalLayout'

export function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 15, 2026">
      <p>
        Welcome to MakerStack. By creating a page or using our service you agree to these terms. If
        you do not agree, please do not use MakerStack.
      </p>
      <h2>1. Your account</h2>
      <p>
        You are responsible for the activity on your account and for keeping your login secure. You
        must be at least 13 years old to use MakerStack. One person or organization per username.
      </p>
      <h2>2. Your content</h2>
      <p>
        You retain ownership of the content you publish (your profile, bio, links and startups). By
        publishing, you grant MakerStack a license to host and display that content as part of the
        service. You are responsible for ensuring you have the rights to anything you upload.
      </p>
      <h2>3. Acceptable use</h2>
      <p>
        Do not use MakerStack to publish unlawful, deceptive, infringing, or abusive content, to
        impersonate others, or to distribute malware. We may remove content or suspend accounts that
        violate these terms.
      </p>
      <h2>4. Payments</h2>
      <p>
        Publishing a page requires a one-time purchase (a 1-Year Pass or a Lifetime Deal). Payments
        are processed by our payment partners (RevenueCat and Stripe). Passes are non-refundable
        except where required by law. The 1-Year Pass keeps your page live for twelve months; the
        Lifetime Deal keeps it live for the lifetime of the service.
      </p>
      <h2>5. Availability</h2>
      <p>
        We aim for high availability but provide MakerStack “as is,” without warranties. We are not
        liable for indirect or incidental damages to the extent permitted by law.
      </p>
      <h2>6. Changes</h2>
      <p>
        We may update these terms; material changes will be reflected by the “last updated” date.
        Continued use after changes constitutes acceptance.
      </p>
      <h2>7. Contact</h2>
      <p>
        Questions? Email <a href="mailto:hello@makerstack.altuzar.dev">hello@makerstack.altuzar.dev</a>.
      </p>
    </LegalLayout>
  )
}
